import React, { useEffect, useState } from 'react';
import { Button, Result } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { Center, Heading, VStack } from '@chakra-ui/react';
import Title from 'antd/es/typography/Title';

const SuccessAndRedirect = () => {
  const [isRedirecting, setIsRedirecting] = useState(true);
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();
  const { state } = useLocation();
  const { redirectURL } = state;

  useEffect(() => {
    if (!isRedirecting) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(timer);
          // Use setTimeout to ensure navigation happens after render
          setTimeout(() => navigate(redirectURL), 0);
          return prev; // Return current value to avoid unnecessary updates
        }
        return prev - 1; // Decrease countdown
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, [isRedirecting, navigate, redirectURL]);

  const progressBtnHandler = () => {
    handleStopRedirect();
    navigate(redirectURL);
  };

  const homeBtnHandler = () => {
    handleStopRedirect();
    navigate('/home');
  };

  /* To prevent auto redirect route if home button clicked*/
  const handleStopRedirect = () => {
    setIsRedirecting(false);
  };

  return (
    <Center h="70vh">
      <VStack>
        <Heading as="h1" size="4xl" noOfLines={1}>
          Thank You!
        </Heading>
        <Result
          status="success"
          title="Request Submitted Successfully!"
          subTitle={
            'Once completed we will send you an email with all reports.'
          }
          extra={[
            <Button key="home" onClick={homeBtnHandler}>
              Go Home
            </Button>,
            <Button key="redirect" type="primary" onClick={progressBtnHandler}>
              See Progress
            </Button>,
          ]}
        />
        <Title level={3}>
          Redirecting to progress in {countdown} seconds...
        </Title>
      </VStack>
    </Center>
  );
};

export default SuccessAndRedirect;
